import type { EmissoesParaMeuCNPJModel } from "../models/emissoesParaMeuCNPJModel"
import { EmissoesParaMeuCNPJActionsTypes } from "./emissoesParaMeuCNPJActions"
import type { EmissoesParaMeuCNPJActions } from "./emissoesParaMeuCNPJActions"

export function emissoesParaMeuCNPJReducer(
    state: EmissoesParaMeuCNPJModel,
    action: EmissoesParaMeuCNPJActions
): EmissoesParaMeuCNPJModel {
    switch (action.type) {
        case EmissoesParaMeuCNPJActionsTypes.CARREGAR:
            return {
                ...state,
                notasServico: action.payload.notasServico ?? [],
                notasMercadoria: action.payload.notasMercadoria ?? [],
                mensagemServico: action.payload.mensagemServico,
                mensagemMercadoria: action.payload.mensagemMercadoria,
            }
        case EmissoesParaMeuCNPJActionsTypes.ATUALIZAR_DATA_INICIAL:
            return { ...state, dataInicial: action.payload }
        case EmissoesParaMeuCNPJActionsTypes.ATUALIZAR_DATA_FINAL:
            return { ...state, dataFinal: action.payload }
        default:
            return state
    }
}
